import React from "react"


function TableBody({
  page,
  getTableBodyProps,
  expandedRow,
  headerGroups,
  prepareRow,
}) {
  return (
    <>
      <tbody {...getTableBodyProps()}>
        {((page || []).length > 0 &&
          (page || []).map(row => {
            prepareRow(row)
            return (
              <React.Fragment key={row.getRowProps().key}>
                <tr
                  style={{
                    cursor: "pointer",
                    backgroundColor: row.original.child && "#e8f4f8"
                  }}
                  {...row.getRowProps()}
                  className={
                    expandedRow === row.id && "table-info bg-opacity-25"
                  }
                >
                  {row.cells.map(cell => {
                    return (
                      <td
                        key={cell.id}
                        {...cell.getCellProps()}
                        data-label={cell.column.Header}
                        style={{
                          ...(cell.column.style || {}),
                        }}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              </React.Fragment>
            )
          })) || (
            <tr>
              <td
                colSpan={headerGroups[0]?.headers?.length}
                className="react-bs-table-no-data p-5 text-center"
              >
                Sorry, There are no data to display
              </td>
            </tr>
          )}
      </tbody>
    </>
  )
}

export default TableBody
